<template>
    <!-- This example requires Tailwind CSS v2.0+ -->
    <div
        class="relative z-20"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
        v-if="visible"
        @keyup.esc="hide"
    >
        <!--
          Background backdrop, show/hide based on modal state.

          Entering: "ease-out duration-300"
            From: "opacity-0"
            To: "opacity-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100"
            To: "opacity-0"
        -->
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div class="fixed z-40 inset-0 overflow-y-auto">
            <div class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <!--
                  Modal panel, show/hide based on modal state.

                  Entering: "ease-out duration-300"
                    From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    To: "opacity-100 translate-y-0 sm:scale-100"
                  Leaving: "ease-in duration-200"
                    From: "opacity-100 translate-y-0 sm:scale-100"
                    To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                -->
                <div
                    class="relative bg-white px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:w-full sm:p-6"
                    :class="modalWidth"
                >
                    <div class="block absolute top-0 right-0 pt-4 pr-4">
                        <button type="button" class="btn-close" @click="cancel">
                            <span class="sr-only">{{ $t('shared.modals.close') }}</span>
                            <icon name="close"/>
                        </button>
                    </div>
                    <div class="sm:flex sm:items-star w-full">
                        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                            <h3 class="text-xl leading-6 font-medium">{{title}}</h3>
                            <div class="mt-2 w-full py-5">
                                <slot/>
                                <slot name="alerts" />
                            </div>
                        </div>
                    </div>
                    <div class="mt-5 sm:mt-4 flex flex-row-reverse" v-if="showCancel || showConfirm">
                        <button
                            v-if="showConfirm"
                            type="button"
                            ref="confirm"
                            class="btn ml-5"
                            :class="{'btn-primary' : !dangerous, 'btn-danger': dangerous, 'disabled': !confirmEnabled}"
                            @click="confirm">{{confirmLabel}}</button>
                        <button v-if="showCancel" type="button" ref="cancel" class="btn btn-secondary ml-5" @click="cancel">{{cancelLabel}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Layout from '@/Shared/Layout';
import Icon from '@/Shared/Icon';


export default {
    layout: Layout,
    components: {
        Icon,
    },
    props: {
        modalSize: {
            type: String,
            default: 'm'
        },
        showCancel: {
            type: Boolean,
            default: true
        },
        showConfirm:  {
            type: Boolean,
            default: true
        },
        title: String,
        labelCancel: String,
        labelConfirm: String,
        dangerous: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visible: false,
            confirmEnabled: true
        }
    },
    computed: {
        cancelLabel() {
            return this.labelCancel ? this.labelCancel : this.$t('shared.modals.cancel');
        },
        confirmLabel() {
            return this.labelConfirm ? this.labelConfirm : this.$t('shared.modals.confirm');
        },
        modalWidth() {
            switch (this.modalSize.toLowerCase()) {
                case 's':
                    return 'sm:max-w-lg';
                case 'm':
                    return 'md:max-w-lg'
                case 'l':
                    return 'lg:w-11/12 xl:w-4/5';
            }
        }
    },
    methods: {
        show() {
            this.visible = true;
            this.$emit('show');
        },
        hide() {
            this.visible = false;
            this.$emit('hide');
        },
        cancel() {
            this.$emit('cancel');
        },
        confirm() {
            this.$emit('confirm');
        },
        enableConfirmButton() {
            this.confirmEnabled = true;
        },
        disableConfirmButton() {
            this.confirmEnabled = false;
        }
    }
}
</script>
